<template>
    <div class="slider-container">
        <div class="slider-wrapper">
            <div :class="activeSlider == 'enterprise-center' ? 'slider-item-active' : 'slider-item'"
                @click="handleSlider('enterprise-center')">
                <div class="slider-icon-wrapper">
                    <img src="../assets/img/slider1.png" alt="" class="slider-icon">
                </div>
                <div class="slider-item-label">企业中心</div>
            </div>
            <div :class="activeSlider == 'study-report-member' || activeSlider == 'study-report-course' ? 'slider-item-active' : 'slider-item'"
                @click="handleSlider('study-report-member')">
                <div class="slider-icon-wrapper">
                    <img src="../assets/img/slider2.png" alt="" class="slider-icon">
                </div>
                <div class="slider-item-label">学习报告</div>
            </div>
            <div :class="activeSlider == 'team-manage' ? 'slider-item-active' : 'slider-item'"
                @click="handleSlider('team-manage')">
                <div class="slider-icon-wrapper">
                    <img src="../assets/img/slider3.png" alt="" class="slider-icon">
                </div>
                <div class="slider-item-label">团队管理</div>
            </div>
            <div v-if="userInfo && userInfo.role == 2"
                :class="activeSlider == 'course-manage' ? 'slider-item-active' : 'slider-item'"
                @click="handleSlider('course-manage')">
                <div class="slider-icon-wrapper">
                    <img src="../assets/img/slider5.png" alt="" class="slider-icon">
                </div>
                <div class="slider-item-label">课程管理</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        sliderVal: {
            type: String
        }
    },
    components: {

    },
    data() {
        return {
            activeSlider: "",
            dept: '',
            token: '',
            userInfo: null
        }
    },
    watch: {
        "$store.state.app.userInfo": {
            handler: function (newVal, oldVal) {
                this.userInfo = newVal;
            },
            deep: true
        },
    },
    mounted() {
        if (this.sliderVal != '') {
            this.activeSlider = this.sliderVal;
        }
        // this.dept=this.$route.params.dept;
        // this.token=this.$route.params.token;
        this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');
        this.userInfo = this.$store.state.app.userInfo;
    },
    methods: {
        handleSlider(target) {
            this.activeSlider = target;
            this.$router.push(`/index/${target}/${this.dept}/${this.token}`);
            this.$emit("sliderVal", target);
        }
    }
}
</script>

<style scoped>
.slider-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.slider-wrapper {
    width: 100%;
    flex: 1;
    background: linear-gradient(141deg, #4A6BEA 0%, #7995FF 100%);
    border-radius: 6px 6px 0px 0px;
    padding-top: 55px;
}

.slider-item {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    height: 38px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.slider-item-active {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    height: 38px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    cursor: pointer;
}

.slider-item:hover {
    cursor: pointer;
    opacity: 0.8;
}

.slider-icon-wrapper {
    position: relative;
    top: 3px;
}

.slider-icon {
    width: 19px;
    height: 20px;
}

.slider-item-label {
    margin-left: 21px;
}</style>


